"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashValue = void 0;
const crypto_1 = require("crypto");
/**
 * creates a string hash of lots of different kinds of things.
 *
 * @example hashValue({someKey: 'someValue'})
 */
const hashValue = (value) => {
    // hack for sorting keys https://stackoverflow.com/a/53593328/14809536
    const allKeys = new Set();
    JSON.stringify(value, (k, v) => (allKeys.add(k), v));
    const strValue = JSON.stringify(value, Array.from(allKeys).sort());
    return (0, crypto_1.createHash)('sha1').update(strValue).digest('hex');
};
exports.hashValue = hashValue;
